import React, { createContext, type ReactNode } from "react";
import { useTranslation } from "react-i18next";

interface IValidationContextType {
  requiredValidation: (value: unknown) => string | undefined;
}

interface IValidationProviderProps {
  children: ReactNode;
}

const ValidationContext = createContext<IValidationContextType>({} as IValidationContextType);

export const ValidationProvider = (props: IValidationProviderProps) => {
  const value = useValidationProvider();
  return <ValidationContext.Provider value={value}>{props.children}</ValidationContext.Provider>;
};

const useValidationProvider = (): IValidationContextType => {
  const { t } = useTranslation();
  const requiredMessage = t("general.form.required_field_warning.text");

  const requiredValidation = (value: unknown): string | undefined => {
    if (value === undefined || value === null) {
      return requiredMessage;
    }

    return undefined;
  };

  return {
    requiredValidation,
  };
};
